import _ from 'lodash';
import { SEGMENT_CONFIG } from 'v2/common/constants/index';
import { schemaShouldShowConfigTypes, schemaTypes } from '../outputSchema/config';
import { pipeInputSchemaTypes } from './config';

const configuration = {
  type: 'anchoredVolumeWeightedAveragePrice',
  defaults: {
    chartConfig: {
      type: 'candle',
      boxUnitSize: 0,
      boxPercentage: 0,
      volumeInterval: '3 minutes',
    },
    type: 'anchoredVolumeWeightedAveragePrice',
    name: 'avwap',
    config: {
      candleInterval: '5 minutes',
      valuePaths: [
        'item0.equity'
      ],
      multiplier: 1,
      price: 'typical',
      anchor: [
        {
          leftOperand: '',
          operator: '',
          rightOperand: '',
          conditionOperator: 'and'
        }
      ],
    }
  },
  inputSchema: [
    {
      name: 'price',
      label: 'Price',
      type: pipeInputSchemaTypes.select,
      options: [
        'open',
        'high',
        'low',
        'close',
        'typical'
      ]
    },
    {
      name: 'anchor',
      label: 'Anchor',
      type: pipeInputSchemaTypes.signal,
    }
  ],
  searchTerms: [
    'AVWAP (Anchored Volume Weighted Average Price)'
  ],
  configFormOptions: {
    valuePathEditable: true,
    configFieldOptions: {},
    valuePathSupportedSegments: [SEGMENT_CONFIG.equity, SEGMENT_CONFIG.future]
  },
  buildOutputSchema: ({ type, name }) => {
    const properties = [
      'vwap',
      'upperBand',
      'lowerBand'
    ];

    return _.map(properties, (property) => {
      return {
        name: `${name}.${property}`,
        type: schemaTypes.number,
        indicatorType: type,
        category: 'indicator',
        label: name === property ? name : `${name} ${property}`,
        shouldShowConfigs: [
          schemaShouldShowConfigTypes.adjustmentLeftOperand,
          schemaShouldShowConfigTypes.adjustmentRightOperand,
          schemaShouldShowConfigTypes.entryLeftOperand,
          schemaShouldShowConfigTypes.entryRightOperand,
          schemaShouldShowConfigTypes.exitLeftOperand,
          schemaShouldShowConfigTypes.exitRightOperand,
          schemaShouldShowConfigTypes.intentValuePath,
        ],
        priority: 70,
        schemaName: name
      };
    });
  },
  isEnabled: true,
};
export default configuration;
